"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var change_type_1 = require("../cd/interface/change-type");
var prop_change_manager_1 = require("../cd/prop-change-manager");
var is_primitive_1 = require("../lang/is-primitive");
var i_st_1 = require("../st/interface/i$st");
var st_1 = require("../st/st");
var type_function_1 = require("../lang/type-function");
var context_1 = require("./decorator/context");
var HANDLER_OWNING_INSTANCE = "HANDLER_OWNING_INSTANCE";
var DEFAULT_CONTEXT_VALUE = {};
// for st.enable(context, ...)
exports.context = context_1.context;
if (!st_1.st.context) {
    /* internal API */
    var callChangeHandlers_1 = function (onChangeHandlers, name, type, value, prevValue, path) {
        if (path === void 0) { path = prop_change_manager_1.DEFAULT_EMPTY_PATH; }
        for (var _i = 0, onChangeHandlers_1 = onChangeHandlers; _i < onChangeHandlers_1.length; _i++) {
            var onChangeHandler = onChangeHandlers_1[_i];
            onChangeHandler({
                name: name,
                type: type,
                path: path,
                value: value,
                prevValue: prevValue,
            });
        }
    };
    var hasContextCacheEntry_1 = function (contextName) {
        return st_1.st[i_st_1.GlobalCache.CONTEXT][contextName];
    };
    var initContextCacheEntry_1 = function (contextName, initialValue) {
        if (!hasContextCacheEntry_1(contextName)) {
            st_1.st[i_st_1.GlobalCache.CONTEXT][contextName] = {
                value: undefined,
                onChangeHandlers: [],
            };
            // set initial value in context cache
            st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].value = initialValue;
            prop_change_manager_1.PropChangeManager.onChange(st_1.st[i_st_1.GlobalCache.CONTEXT][contextName], "value", change_type_1.ChangeType.DEEP, function (value, prevValue) {
                callChangeHandlers_1(st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers, contextName, change_type_1.ChangeType.REFERENCE, value, prevValue);
            }, function (path, value, prevValue) {
                // prevent proxy on proxy change handler recursions
                if (!path.startsWith('Symbol')) {
                    callChangeHandlers_1(st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers, contextName, change_type_1.ChangeType.DEEP, value, prevValue, path);
                }
            });
        }
    };
    /* public API */
    /**
     * Initializes a global context object
     * @param contextName App-wide unique name of the context
     * @param initialValue Initial value. Must be an Object or Array
     * @param onChange Handler function to be applied when the context object gets changed by reference or deeply
     * @param instance Optional instance reference to allow for correct GC. Should be used with @Share
     */
    st_1.st.context = function context(contextName, initialValue, onChange, instance) {
        if (!initialValue) {
            initialValue = {};
        }
        if (is_primitive_1.isPrimitive(initialValue)) {
            throw new Error("A context cannot be a primitive value like " + initialValue + ". Wrap the value of " + contextName.toString() + " in an object.");
        }
        if (!hasContextCacheEntry_1(contextName)) {
            initContextCacheEntry_1(contextName, initialValue || DEFAULT_CONTEXT_VALUE);
        }
        exports.addContextChangeHandler(contextName, onChange, instance);
        return st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].value;
    };
}
else {
    if (process.env.NODE_ENV === 'development') {
        st_1.st.warn('Module context is loaded twice. Check for duplicate famework import!');
    }
}
/**
 * Registers a change handler for a global context object to be called on reference or deep change.
 * @param contextName App-wide unique name of the context
 * @param onChange Handler function, called on change
 * @param instance Optional instance reference to allow for correct GC. Should be used with @Share
 */
exports.addContextChangeHandler = (st_1.st.addContextChangeHandler = function (contextName, onChange, instance) {
    if (typeof onChange == type_function_1.TYPE_FUNCTION) {
        if (instance) {
            onChange[HANDLER_OWNING_INSTANCE] = instance;
        }
        st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers.push(onChange);
    }
});
/**
 * Removes single change handlers for cases where the functional API is used.
 * @param contextName Name reference of the context
 * @param [onChange] Handler function reference. Must equal (===) the orginal function registered
 */
exports.removeContextChangeHandler = (st_1.st.removeContextChangeHandler = function (contextName, onChange) {
    var index = st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers.indexOf(onChange);
    if (index > -1) {
        st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers.splice(index, 1);
    }
});
/**
 * Used for class instance GC. Removes all change handlers that belong to a GC'd instance.
 * @param instance Custom element instance or generic class instance
 */
exports.removeContextChangeHandlersOfInstance = function (instance) {
    if (st_1.st[i_st_1.GlobalCache.CONTEXT]) {
        for (var contextName in st_1.st[i_st_1.GlobalCache.CONTEXT]) {
            st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers = st_1.st[i_st_1.GlobalCache.CONTEXT][contextName].onChangeHandlers.filter(function (onChange) {
                if (onChange && onChange[HANDLER_OWNING_INSTANCE] && onChange[HANDLER_OWNING_INSTANCE] === instance) {
                    return false;
                }
                return true;
            });
        }
    }
};
//# sourceMappingURL=context.js.map